import { initModal } from './libs/_modal';

const setModal = () => {
  const modals = document.querySelectorAll(".modal");
  modals.forEach(
    (modal) => {
      const triggers = document.querySelector('[data-modal-trigger="' + modal.id + '"]');
      const closeButton = modal.querySelector('.modal-close');
    
      initModal({
        modal,
        triggers,
        closeButton
      });
    }
  )
  
}

window.addEventListener('load',function (){
  setModal();
});